module.exports = __webpack_public_path__ + "static/media/CL60_SE.60faf018.jpg";